import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';

const CellLink = styled.a`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  height: 100%;
  padding: 0 20px 0 24px;
  border-right: 1px solid var(--stroke-light, #dddde2);

  &:active {
    background: var(--background-light-blue, #eef2f9);
  }
`;

const LogoImg = styled.img`
  width: 26px;
  height: 23px;
`;

const LogoCell = ({ href }: { href: string }) => (
  <CellLink href={href} aria-label="Academia.edu home" data-testid="logo-cell">
    <LogoImg
      src={$image_url('academia-logo-2021.svg')}
      alt=""
      data-testid="logo-img"
    />
  </CellLink>
);

export default LogoCell;
